import { createFileRoute } from "@tanstack/react-router";
import TripsPage from "@/components/trips/trips-page";

function TripsPageRoute() {
  return <TripsPage />;
}

export const Route = createFileRoute("/_app/trips/")({
  component: TripsPageRoute,
});
